'use client';

/* eslint-disable prettier/prettier */
var translations = {
    'characters remaining': ' ký tự còn lại',
    'You have entered too many characters': 'Bạn đã nhập quá nhiều ký tự'
};

export { translations as default };
//# sourceMappingURL=translate.js.map
